/**
 * Theme JS entry point.
 *
 * Aggregates every web component module. Each imported module self-registers
 * its custom element via `customElements.define`, so importing here is enough
 * to make the component available anywhere it appears in the DOM. Add new
 * components to this list as they are built.
 */
import './disclosure.js';
import './header.js';
import './cart-icon.js';
import './cart-drawer.js';
import './cart-page.js';
import './product-form.js';
import './variant-picker.js';
import './quantity-input.js';
import './facets.js';
import './predictive-search.js';
